module.exports = __webpack_public_path__ + "rodovia-pan-americana.dd8fd15ff40ecaaf582984e2a4720917.jpg";